import type { ComponentProps } from "react"
import ViewSheet from "@/v2-backoffice-client/components/viewSheet"
import NavLayerEnableButton from "@/v2-backoffice-client/navlayer/enable/NavLayerEnableButton"
import type { NavLayerFragment } from "@/v2-backoffice-client/navlayer/__types__/navlayer.fragment"

export type NavLayerViewToolbarProps = ComponentProps<"div"> & {
  navLayer: NavLayerFragment | null | undefined
}

/**
 * Lifecycle controls for the nav layer sheet. Like basemaps, nav layers
 * skip the layer review queue, so publish/withdraw is the whole lifecycle.
 */
function NavLayerViewToolbar(props: NavLayerViewToolbarProps) {
  const { navLayer, ...viewSheetToolbarProps } = props

  if (!navLayer) return null

  return (
    <ViewSheet.Toolbar {...viewSheetToolbarProps}>
      <NavLayerEnableButton navLayer={navLayer} />
    </ViewSheet.Toolbar>
  )
}

export default NavLayerViewToolbar
